import { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import { Container } from 'Components/Container';
import { gutters } from 'Theme/Variables';
import { useLocalization } from 'Hooks';
import { routePath } from 'Navigator/routes';
import { useHistory } from 'react-router-dom';
import { QuestionMarkIcon, NavigationIcon, PhoneIcon, IbbGrayIcon, BelbimGrayIcon, TinyCardIcon } from 'Components/Svg';
import { userStore } from 'Stores/User';
import { useSelector } from 'react-redux';

import './DashboardFooter.scss';

const DashboardFooter: FC = () => {
  const {
    web_footer_istanbulkart_hakkinda,
    web_footer_yukleme_harcama_noktalari,
    web_footer_sik_sorulan_sorular,
    web_footer_bize_ulasin,
    web_about_istanbulkart,
    web_footer_yuklemenoktalari,
  } = useLocalization();

  const history = useHistory();
  const userData = useSelector(userStore);
  const isResetPassword = userData?.resetPassword;

  const handleIstanbulkartHakkinda = () => {
    window.open(web_about_istanbulkart);
  };

  const showDiscover = web_footer_yuklemenoktalari !== '0';
  const linkCount = 3 + (showDiscover ? 1 : 0);
  const isHorizontal = linkCount <= 3;

  const linkIstanbulkart = (
    <Box display="flex" alignItems="center" marginBottom={gutters.regular} className="dashboardFooter--links">
      <TinyCardIcon />
      <Box
        marginLeft={gutters.small}
        onClick={() => handleIstanbulkartHakkinda()}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleIstanbulkartHakkinda();
          }
        }}
        itemID="istanbulkartHakkındaBtnTest"
      >
        <Typography>{web_footer_istanbulkart_hakkinda}</Typography>
      </Box>
    </Box>
  );

  
  const linkDiscover = showDiscover ? (
    <Box
      display="flex"
      alignItems="center"
      marginBottom={gutters.regular}
      className="dashboardFooter--links"
      onClick={() => history.push(routePath.discover)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          history.push(routePath.discover);
        }
      }}
      itemID="discoverBtnTest"
    >
      <NavigationIcon />
      <Box marginLeft={gutters.small}>
        <Typography> {web_footer_yukleme_harcama_noktalari}</Typography>
      </Box>
    </Box>
  ) : null;

  const linkContact = (
    <Box
      display="flex"
      alignItems="center"
      marginBottom={gutters.regular}
      className="dashboardFooter--links"
      onClick={isResetPassword ? undefined : () => history.push(routePath.contact)}
      role="button"
      tabIndex={isResetPassword ? -1 : 0}
      aria-disabled={isResetPassword}
      onKeyDown={(e) => {
        if (isResetPassword) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          history.push(routePath.contact);
        }
      }}
      itemID="faqBtnTest"
    >
      <PhoneIcon />
      <Box marginLeft={gutters.small}>
        <Typography>{web_footer_bize_ulasin}</Typography>
      </Box>
    </Box>
  );

  const linkFaq = (
    <Box
      onClick={() => history.push(routePath.faq)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          history.push(routePath.faq);
        }
      }}
      display="flex"
      alignItems="center"
      marginBottom={gutters.regular}
      className="dashboardFooter--links"
      itemID="contactBtnTest"
    >
      <QuestionMarkIcon />
      <Box marginLeft={gutters.small}>
        <Typography> {web_footer_sik_sorulan_sorular}</Typography>
      </Box>
    </Box>
  );

  return (
    <footer id="dashboardFooter">
      <Container>
        <div className="dashboardFooter__wrapper">
          <nav aria-label="Alt gezinim" className="dashboardFooter__links">
            {isHorizontal ? (
              <div className="dashboardFooter__links-row">
                {linkIstanbulkart}
                {linkContact}
                {linkFaq}
              </div>
            ) : (
              <div className="dashboardFooter__links-row">
                <div className="dashboardFooter__links-col">
                  {linkIstanbulkart}
                  {linkDiscover}
                </div>
                <div className="dashboardFooter__links-col">
                  {linkContact}
                  {linkFaq}
                </div>
              </div>
            )}
          </nav>
          <div className="dashboardFooter__right--logo">
            <IbbGrayIcon />
            <Box marginLeft={gutters.regular}>
              <BelbimGrayIcon />
            </Box>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default DashboardFooter;
